// Copyright (c) 2023, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 Inc. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import * as React from 'react';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import UserTravelDocumentList from './travel_document/UserTravelDocumentList';
import UserVisaList from './visa/UserVisaList';
import "../../css/UserProfile.scss"
import { Button } from '@mui/material';
import { ReactComponent as TravelDocumentSvg } from "../../icons/mytraveldocument.svg"
import { ReactComponent as VisaSvg } from "../../icons/myvisa.svg"

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <div>{children}</div>
                </Box>
            )}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const UserProfile = () => {

    const [value, setValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <div className='User-profile'>
            <Box className='User-profile-box'>

                <AppBar position="static">
                    <Tabs value={value} onChange={handleChange}
                        // TabIndicatorProps={{
                        //     style: {
                        //         backgroundColor: "#D97D54"
                        //     }
                        // }}
                        indicatorColor="secondary"
                        textColor="inherit">
                        {/* <Tab label="User Profile" {...a11yProps(2)} className='Tab-label' /> */}
                        <Tab label={
                            <Button startIcon={<TravelDocumentSvg />} color="secondary" onClick={() => { }} size='small' className='Tab-label' >
                                {"My Travel Documents"}
                            </Button>
                        } {...a11yProps(0)} className='Tab-label' />
                        <Tab label={
                            <Button startIcon={<VisaSvg />} color="secondary" onClick={() => { }} size='small' className='Tab-label' >
                                {"My Visa Details"}
                            </Button>
                        } {...a11yProps(1)} />
                    </Tabs>
                </AppBar>
            </Box>
            {/* <TabPanel value={value} index={0}>
                User Profile
            </TabPanel> */}
            <TabPanel value={value} index={0} children={(<UserTravelDocumentList />)}>

            </TabPanel>
            <TabPanel value={value} index={1} children={(<UserVisaList />)}>
            </TabPanel>
        </div>
    );
}

export default UserProfile;